import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. Aceitação dos Termos',
    content: `Ao criar uma conta ou utilizar qualquer funcionalidade do MyBank, você declara ter lido, compreendido e concordado integralmente com estes Termos de Uso e com nossa Política de Privacidade.

Se você não concordar com qualquer parte destes termos, não utilize o serviço.`,
  },
  {
    title: '2. Descrição do Serviço',
    content: `O MyBank é uma plataforma de gestão financeira pessoal oferecida como SaaS (Software como Serviço) que permite ao usuário:

- Registrar e categorizar transações financeiras
- Acompanhar saldo de múltiplas contas
- Definir metas e orçamentos
- Visualizar relatórios e projeções financeiras
- Gerenciar investimentos e simulações
- Compartilhar acesso com membros da família (plano Família)

O MyBank **não é** uma instituição financeira, não oferece produtos financeiros regulados, e não possui acesso às contas bancárias dos usuários.`,
  },
  {
    title: '3. Elegibilidade',
    content: `Para usar o MyBank você deve:

- Ter no mínimo 18 anos ou ser emancipado civilmente
- Ser pessoa física residente no Brasil
- Fornecer informações verídicas no cadastro
- Possuir capacidade civil para assumir obrigações legais

Empresas podem usar o MyBank apenas em nome de seus funcionários com autorização expressa.`,
  },
  {
    title: '4. Conta de Usuário',
    content: `**Criação:** Você é responsável por fornecer informações corretas e atualizadas no cadastro.

**Segurança:** Você é responsável por manter a confidencialidade da sua senha e por todas as atividades realizadas na sua conta. Em caso de uso não autorizado, notifique-nos imediatamente em suporte@mybank.com.br.

**Uma conta por pessoa:** É vedado criar múltiplas contas para uma mesma pessoa com o objetivo de burlar limites do plano gratuito.

**Suspensão:** Reservamo-nos o direito de suspender contas em caso de violação destes termos ou uso fraudulento.`,
  },
  {
    title: '5. Planos e Pagamentos',
    content: `**Plano Free:** Gratuito e sem limitação de tempo, sujeito aos limites descritos na página de preços. Não requer cartão de crédito.

**Planos pagos (Pro e Família):** Cobrados mensalmente ou anualmente via cartão de crédito processado pelo Stripe. Os valores são exibidos em reais e incluem todos os impostos aplicáveis.

**Renovação automática:** As assinaturas renovam automaticamente no período contratado. Você receberá um e-mail de aviso 7 dias antes da renovação.

**Cancelamento:** Você pode cancelar a qualquer momento nas configurações da conta. Ao cancelar, seu plano permanece ativo até o fim do período já pago, sem cobranças adicionais.

**Reembolso:** Oferecemos reembolso integral em até 14 dias após a contratação, se você não estiver satisfeito. Solicite em suporte@mybank.com.br.

**Inadimplência:** Em caso de falha no pagamento, tentaremos cobrar por 3 dias consecutivos antes de fazer downgrade para o plano Free.`,
  },
  {
    title: '6. Uso Aceitável',
    content: `Você concorda em usar o MyBank apenas para fins legítimos de gestão financeira pessoal. É expressamente proibido:

- Usar automação, bots ou scripts para acesso não autorizado
- Tentar obter acesso não autorizado a contas de outros usuários
- Usar o serviço para fins ilegais ou que violem direitos de terceiros
- Revender ou sublicenciar o acesso ao serviço
- Fazer engenharia reversa, descompilar ou tentar extrair o código-fonte
- Realizar ataques de negação de serviço (DDoS) ou qualquer forma de abuso técnico

O descumprimento dessas regras resultará em suspensão imediata da conta, sem direito a reembolso.`,
  },
  {
    title: '7. Dados e Propriedade',
    content: `**Seus dados:** Todos os dados financeiros que você cadastra no MyBank são de sua propriedade. Concedemos a você direitos plenos sobre seus dados, incluindo a exportação a qualquer momento.

**Nossa propriedade intelectual:** O código, design, marca, logotipo e conteúdo do MyBank são protegidos por direitos autorais e marcas registradas. Você não adquire nenhum direito sobre nossa propriedade intelectual ao usar o serviço.

**Dados agregados:** Podemos usar dados anonimizados e agregados (sem identificação pessoal) para melhorar nossos modelos de IA e produto. Esses dados não permitem identificar você individualmente.`,
  },
  {
    title: '8. Disponibilidade e SLA',
    content: `Comprometemo-nos a manter o serviço disponível, mas não garantimos disponibilidade ininterrupta. Nossa meta de uptime é de 99,5% mensais.

Manutenções programadas serão avisadas com mínimo de 24h de antecedência por e-mail. Incidentes inesperados serão comunicados em nossa página de status.

Não somos responsáveis por perdas decorrentes de indisponibilidade temporária do serviço.`,
  },
  {
    title: '9. Limitação de Responsabilidade',
    content: `O MyBank é uma **ferramenta de organização financeira**, não um serviço de assessoria financeira regulado. Não somos responsáveis por:

- Decisões financeiras tomadas com base em dados do aplicativo
- Imprecisões nos dados inseridos pelo próprio usuário
- Perdas financeiras de qualquer natureza
- Danos indiretos, consequenciais ou punitivos

Nossa responsabilidade total está limitada ao valor pago pelo serviço nos 12 meses anteriores ao evento que originou o dano.`,
  },
  {
    title: '10. Modificações nos Termos',
    content: `Podemos modificar estes Termos a qualquer momento. Alterações relevantes serão comunicadas por e-mail com antecedência mínima de 30 dias. O uso continuado após esse prazo implica aceitação dos novos termos.

Para alterações urgentes relacionadas a segurança ou exigências legais, o prazo pode ser menor, mas sempre notificaremos você.`,
  },
  {
    title: '11. Encerramento',
    content: `Você pode encerrar sua conta a qualquer momento nas configurações. Após o encerramento, seus dados serão excluídos conforme descrito na Política de Privacidade.

Podemos encerrar ou suspender sua conta por violação destes termos, notificando você por e-mail quando possível.`,
  },
  {
    title: '12. Legislação e Foro',
    content: `Estes Termos são regidos pelas leis brasileiras. Em caso de disputas não resolvidas amigavelmente, fica eleito o foro da Comarca de São Paulo/SP, com renúncia expressa a qualquer outro, por mais privilegiado que seja.`,
  },
  {
    title: '13. Contato',
    content: `Para questões sobre estes Termos:

**E-mail:** legal@mybank.com.br
**MyBank Tecnologia Ltda.**
Av. Brigadeiro Faria Lima, 1234 — São Paulo/SP — CEP 01451-001`,
  },
];

const renderContent = (content) =>
  content.split('\n\n').filter(Boolean).map((block, i) => {
    const lines = block.split('\n');
    const isListBlock = lines.some((l) => l.startsWith('- '));

    if (isListBlock) {
      return (
        <ul key={i} className="list-disc list-inside space-y-1 my-3 text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
          {lines.filter((l) => l.startsWith('- ')).map((l, j) => (
            <li key={j} dangerouslySetInnerHTML={{ __html: l.slice(2).replace(/\*\*(.*?)\*\*/g, '<strong class="text-gray-900 dark:text-white">$1</strong>') }} />
          ))}
        </ul>
      );
    }

    return (
      <p key={i} className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed mb-3"
        dangerouslySetInnerHTML={{ __html: block.replace(/\*\*(.*?)\*\*/g, '<strong class="text-gray-900 dark:text-white">$1</strong>') }} />
    );
  });

const TermsContent = () => (
  <div className="space-y-8">
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-5">
      <p className="font-semibold text-blue-900 dark:text-blue-200 mb-3">Resumo dos pontos principais:</p>
      <ul className="space-y-1.5 text-blue-800 dark:text-blue-300 text-sm">
        <li>✓ O MyBank é uma ferramenta de organização, não um banco ou assessoria regulada</li>
        <li>✓ Você tem 14 dias para solicitar reembolso sem justificativa</li>
        <li>✓ Seus dados são seus — você pode exportar ou excluir a qualquer momento</li>
        <li>✓ Cancele quando quiser, sem multas ou contratos</li>
        <li>✓ Regido pelas leis brasileiras, foro em São Paulo/SP</li>
      </ul>
    </div>
    <div className="space-y-8">
      {sections.map((s) => (
        <div key={s.title} id={s.title}>
          <h2 className="text-base font-bold text-gray-900 dark:text-white mb-3 pb-2 border-b border-gray-200 dark:border-gray-800">
            {s.title}
          </h2>
          {renderContent(s.content)}
        </div>
      ))}
    </div>
    <p className="text-sm text-gray-500 pt-4 border-t border-gray-200 dark:border-gray-800">
      Dúvidas legais?{' '}
      <a href="mailto:legal@mybank.com.br" className="text-primary-600 hover:text-primary-700 font-medium">
        legal@mybank.com.br
      </a>
    </p>
  </div>
);

const Terms = ({ embedded = false }) => {
  if (embedded) return <TermsContent />;

  return (
    <div className="bg-white dark:bg-gray-950 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-b from-gray-950 to-gray-900 py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-white mb-4">Termos de Uso</h1>
          <p className="text-gray-400">Última atualização: 1º de março de 2025</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-2xl p-6 mb-12">
          <p className="font-semibold text-blue-900 dark:text-blue-200 mb-3">Resumo dos pontos principais:</p>
          <ul className="space-y-1.5 text-blue-800 dark:text-blue-300 text-sm">
            <li>✓ O MyBank é uma ferramenta de organização, não um banco ou assessoria regulada</li>
            <li>✓ Você tem 14 dias para solicitar reembolso sem justificativa</li>
            <li>✓ Seus dados são seus — você pode exportar ou excluir a qualquer momento</li>
            <li>✓ Cancele quando quiser, sem multas ou contratos</li>
            <li>✓ Regido pelas leis brasileiras, foro em São Paulo/SP</li>
          </ul>
        </div>

        <div className="bg-gray-50 dark:bg-gray-900 rounded-2xl p-6 mb-12 border border-gray-200 dark:border-gray-800">
          <p className="font-semibold text-gray-900 dark:text-white mb-3 text-sm">Índice</p>
          <ol className="space-y-1 columns-2">
            {sections.map((s) => (
              <li key={s.title}>
                <a href={`#${s.title}`} className="text-xs text-primary-600 hover:underline">{s.title}</a>
              </li>
            ))}
          </ol>
        </div>

        <div className="space-y-10">
          {sections.map((s) => (
            <div key={s.title} id={s.title}>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4 pb-2 border-b border-gray-200 dark:border-gray-800">
                {s.title}
              </h2>
              {renderContent(s.content)}
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            Dúvidas legais?{' '}
            <a href="mailto:legal@mybank.com.br" className="text-primary-600 hover:text-primary-700 font-medium">
              legal@mybank.com.br
            </a>
          </p>
          <Link to="/privacy" className="text-sm text-primary-600 hover:text-primary-700 font-medium">
            Ver Política de Privacidade →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;
